import React from "react";
import { Dropdown } from "react-bootstrap";
import { Box, Stack, Typography } from "@mui/material";

export function PriestListToolbar({
  total,
  searchKey,
  onSearch,
  isAdmin,
  onExportExcel,
  onExportPdf,
}: {
  total: number;
  searchKey: string;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isAdmin: boolean;
  onExportExcel: () => void;
  onExportPdf: () => void;
}) {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      useFlexGap
      sx={{ mb: 1.5, width: "100%", minWidth: 0 }}
    >
      <Typography
        className="card-title card_head"
        sx={{ m: 0, flex: "1 1 180px", fontSize: { xs: "1.05rem", sm: "1.25rem" } }}
      >
        Spiritual Directors (Priests/Deacons): {total}
      </Typography>
      <Box
        className="form-group content1"
        sx={{ flex: "1 1 220px", minWidth: 0, maxWidth: { sm: 360 }, mb: "0 !important" }}
      >
        <div className="input-group setSearch">
          <input
            onChange={onSearch}
            type="text"
            className="form-control searchData"
            placeholder="Search..."
            aria-label="Search spiritual directors"
            value={searchKey}
          />
          <div className="input-group-append">
            <button className="btn btn-sm btn-primary" type="button">
              <i className="icon-search"></i>
            </button>
          </div>
        </div>
      </Box>
      {isAdmin ? (
        <Box className="import_buttons content1" sx={{ flex: "0 0 auto" }}>
          <Dropdown className="exportPreist d-inline-flex align-items-center">
            <Dropdown.Toggle
              className="btn btn-outline-primary btn-sm d-inline-flex align-items-center"
              id="dropdown-basic"
              style={{ height: "34px" }}
            >
              <i className="icon-download me-1"></i>
              Export
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={onExportExcel}>Excel</Dropdown.Item>
              <Dropdown.Item onClick={onExportPdf}>PDF</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Box>
      ) : null}
    </Stack>
  );
}
